import axios from 'axios'

// 创建axios实例
const apiClient = axios.create({
  baseURL: '/api', // 后端API基础URL
  timeout: 30000 // 请求超时时间（30秒）
})

// 请求拦截器 - 添加JWT token
apiClient.interceptors.request.use(
  (config) => {
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器 - 处理通用错误
apiClient.interceptors.response.use(
  (response) => {
    // 直接返回响应数据，保持原有格式
    return response.data
  },
  (error) => {
    console.error('API响应错误:', error)
    
    // 处理401未授权错误
    if (error.response && error.response.status === 401) {
      // 清除本地存储的token
      localStorage.removeItem('token')
      localStorage.removeItem('adminAuth')
      localStorage.removeItem('adminUser')
      
      // 在SPA模式下，优先使用Vue Router进行路由跳转
      if (window.vm && window.vm.$router) {
        window.vm.$router.push('/login')
      } else {
        // 备用方案：直接跳转
        window.location.href = '/login'
      }
    }
    
    // 构造统一的错误响应格式
    const errorResponse = {
      success: false,
      message: error.response?.data?.error || error.response?.data?.message || error.message || '网络请求失败'
    }
    
    // 抛出异常让上层catch处理
    return Promise.reject(errorResponse)
  }
)

export default apiClient